import './App.css';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'
import Home from './Components/main/Home'
import About from './Components/main/About'
import TeamComponent from './Components/TeamComponent';
import Services from './Components/main/Services';
import Loan from './Components/main/LoanComponent'
import Blog from './Components/main/Blog';
import BlogDetails from './Components/main/BlogDetails';
import Contact from './Components/main/Contact';
import Partner from './Components/main/Partner';
import LoanCalculator from './Components/main/LoanCalculator';

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path ="/">
            <Home />
          </Route>
          <Route path ="/about">
            <About />
          </Route>
          <Route path ="/team">
            <TeamComponent />
          </Route>
          <Route path ="/services">
            <Services />
          </Route>
          <Route path ="/loans">
            <Loan />
          </Route>
          <Route path ="/loans">
            <Loan />
          </Route>
          <Route path ="/blog">
            <Blog />
          </Route>
          <Route path ="/details/:id">
            <BlogDetails />
          </Route>
          <Route path ="/contact">
            <Contact/>
          </Route>
          <Route path ="/partner">
            <Partner/>
          </Route>
          <Route path ="/LoanCalculator">
            <LoanCalculator/>
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
